import * as DOMHelpers from './DOMHelpers';

export function initialize() {

    DOMHelpers.iterateQuerySelectorAll(document, '.js-scrool-left', function(scroller) {
		console.log('333');
        let area = scroller.querySelector('.js-scrool-area');

        let images = area.querySelectorAll('img');
		let imageCount = images.length;

		let checkInteval = setInterval(function() {
			let imageLoaded = 0;

			images.forEach(function(image) {
				if(image.complete) {
					imageLoaded += 1;
				}
			});

			console.log('4444');

			if(imageLoaded === imageCount) {
				console.log('123');
				let areaClone = area.cloneNode(true);
				area.after(areaClone);

				let areaDOM = area;
				let areaCloneDOM = areaClone;

				let areaLimit = 100000;
				let areaCounter = 0;
				let areaCloneCounter = 0;
				areaLimit = area.offsetWidth;
				console.log(areaLimit);

				setInterval(function() {
					areaCounter -= 1;
					areaCloneCounter -= 1;

					areaDOM.style.left = areaCounter+'px';
					areaCloneDOM.style.left = areaCloneCounter+'px';

					if(areaCounter < -1 * areaLimit) {
						areaDOM.style.left = areaLimit+'px';
						areaCounter = areaLimit;
					}

					if(areaCloneCounter < -2 * areaLimit) {
						areaDOM.style.left = '0px';
						areaCloneCounter = 0;
					}
				}, 20);

				clearInterval(checkInteval);
			}
		}, 100);
    });
}

